export enum ErrorCode {
  UserNotActive = 'USER_NOT_ACTIVE',
  UserAlreadyExists = 'USER_ALREADY_EXISTS',
  UserAlreadyActive = 'USER_ALREADY_ACTIVE',
  UserRegistrationEmailFailed = 'USER_REGISTRATION_EMAIL_FAILED',
  UserActivationEmailFailed = 'USER_ACTIVATION_EMAIL_FAILED',
  UserResetPasswordEmailFailed = 'USER_RESET_PASSWORD_EMAIL_FAILED',

  InvalidCredentials = 'INVALID_CREDENTIALS',
  InvalidToken = 'INVALID_TOKEN',
  ExpiredToken = 'EXPIRED_TOKEN',

  HttpException = 'HTTP_EXCEPTION',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  UnknownError = 'UNKNOWN_ERROR',

  EmailDeliveryFailed = 'EMAIL_DELIVERY_FAILED',

  ForeignKeyViolation = 'FOREIGN_KEY_VIOLATION',
  EntityAlreadyExists = 'ENTITY_ALREADY_EXISTS',
  RecordNotFound = 'RECORD_NOT_FOUND',
}
